import React from "react";
import AnimeList from "./AnimeList";
import Navbarr from "./Navbar";

const Popular = () => {
  return (
    <div>
      <Navbarr />
      <AnimeList />
    </div>
  );
};

export default Popular;
